// extracted by mini-css-extract-plugin
export default {"box":"ReviewButtons_box__XtVR8","link":"ReviewButtons_link__F1oQZ"};